// extracted by mini-css-extract-plugin
module.exports = {"container":"EventConversationRoom_container__2qGFp"};